function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_di)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.97656 23.8C3.97656 16.5193 3.97656 12.879 5.39348 10.0981C6.63983 7.65202 8.62858 5.66327 11.0747 4.41692C13.8555 3 17.4959 3 24.7766 3H36.9319C44.2126 3 47.853 3 50.6338 4.41692C53.0799 5.66327 55.0687 7.65202 56.315 10.0981C57.7319 12.879 57.7319 16.5193 57.7319 23.8V36.1492C57.7319 43.4298 57.7319 47.0702 56.315 49.851C55.0687 52.2971 53.0799 54.2859 50.6338 55.5322C47.853 56.9492 44.2126 56.9492 36.9319 56.9492H24.7766C17.4959 56.9492 13.8555 56.9492 11.0747 55.5322C8.62858 54.2859 6.63983 52.2971 5.39348 49.851C3.97656 47.0702 3.97656 43.4298 3.97656 36.1492V23.8Z",
  fill: "#EEEEEE"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M37.7138 19.4645C38.4298 15.4013 38.7878 12.6515 38.7878 11.9608C38.7878 11.5739 38.664 11.2975 38.4158 11.1316C38.168 10.9657 37.7277 10.8891 37.0944 10.8891C36.64 10.8891 35.9514 11.0625 35.4834 11.422C35.0427 11.7812 34.7124 12.3754 34.4919 13.2046C33.8313 15.664 33.1428 18.1096 32.4266 19.7954C31.7384 21.4812 31.1773 22.8887 30.4672 23.8601C29.445 25.2588 27.0202 25.9757 26.4122 24.2517C25.9785 23.0218 26.2469 21.7303 26.4122 20.7079C26.5775 19.6577 26.7701 18.566 26.9907 17.433C27.156 16.604 27.3762 15.3055 27.6516 14.283C27.9543 13.0117 28.106 12.2656 28.106 12.0446C28.106 11.6576 27.9822 11.3676 27.7344 11.174C27.5142 10.9804 27.1012 10.8837 26.4954 10.8902C25.4418 10.9013 25.4125 10.8145 24.917 11.174C24.4213 11.5332 24.1503 12.086 23.8749 12.9149C23.2413 14.8494 22.7872 17.0601 22.5118 18.8013C22.0004 21.9846 20.3156 29.4086 26.9316 29.4086C30.0092 29.4086 31.879 27.8158 32.895 26.4369L32.1729 29.4086L32.1739 29.4089C32.1638 29.4499 31.3856 32.6726 30.7659 35.1845C30.0653 38.2883 28.3899 45.5109 24.4589 45.5109C23.4666 45.5109 23.1084 44.6549 23.1084 43.7976C23.1084 40.1059 26.7954 37.783 29.6068 35.6964C29.9329 34.3124 30.4895 31.995 30.8108 30.6454C26.8945 32.8833 21.7844 36.3238 19.5848 40.4125C18.3273 42.7499 18.5726 46.3493 20.3821 48.1093C21.2632 48.9937 22.4061 49.4356 23.8105 49.4356C30.653 49.4356 33.7677 43.7237 35.3263 34.2632C36.1317 29.3318 36.9199 24.3978 37.7138 19.4645Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M41.9618 18.5803C41.529 22.3584 39.3346 26.2656 37.4255 27.832L36.6001 32.7301C39.1116 31.4471 41.8735 29.138 43.1467 26.5144C43.7714 25.2269 44.5968 22.4576 44.2295 19.5495C43.9429 17.279 42.0843 17.5109 41.9618 18.5803Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_di",
  x: 0.976562,
  y: 0,
  width: 61.7554,
  height: 61.9492,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 1,
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "shape",
  result: "effect2_innerShadow"
})));

var SvgYoelloIconNew = function SvgYoelloIconNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 62,
    viewBox: "0 0 63 62",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYoelloIconNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yoelloIcon_new.19e5f01d.svg";
export { ForwardRef as ReactComponent };